module.exports = __webpack_public_path__ + "static/img/hh-tell-trust.07a021bc.png";